import { render, staticRenderFns } from "./SearchByTag.vue?vue&type=template&id=58b39f0e&"
import script from "./SearchByTag.vue?vue&type=script&lang=js&"
export * from "./SearchByTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SearchByTag.vue"
export default component.exports